import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { UserPathStepProgress } from 'components/common';
import { BoxTableCell } from 'components/common/box';
import { PathCompletionStatus } from 'components/paths';

import type { PageState } from 'types';
import {
  filterValuesSeparator,
  filterValuesSeparatorSplitRegex
} from 'shared-helpers/consts';

interface Props {
  returnPart: 'header' | 'body';
  user?: PageState['user'];
}

const UsersViewPath = ({ returnPart, user }: Props) => {
  const {
    messages,
    pageState: { usersPathData }
  } = useReduxState();

  const router = useRouter();

  const pathData =
    usersPathData?.[
      (router?.query?.view as string)
        ?.split(filterValuesSeparatorSplitRegex)
        ?.slice(1)
        .join(filterValuesSeparator)
    ]?.[user?.id];

  return returnPart === 'header' ? (
    <>
      <BoxTableCell>{messages.commonProgress}</BoxTableCell>
      <BoxTableCell>{messages.commonCompleted}</BoxTableCell>
    </>
  ) : returnPart === 'body' && pathData ? (
    <>
      <BoxTableCell label={messages.commonProgress}>
        <UserPathStepProgress
          progressData={pathData}
          progressStyle={{ marginTop: 7 }}
        />
      </BoxTableCell>
      <BoxTableCell label={messages.commonCompleted}>
        {pathData.pathCompletion ? (
          <PathCompletionStatus
            pathCompletion={pathData.pathCompletion}
            showDate={true}
          />
        ) : null}
      </BoxTableCell>
    </>
  ) : null;
};

export default UsersViewPath;
